import { useTooltip } from "hooks/useTooltip";

export const Floaty = () => {
    const { tooltipRef } = useTooltip({ title: "Bert", placement: "bottom" });

    return (
        <div id="floaty" ref={tooltipRef}>
            <div className="little-dude">
                <figure className="dude-body">
                    <span className="face">
                        <span className="eyes">
                            <span className="eye eye-left"></span>
                            <span className="eye eye-right"></span>
                        </span>
                        <span className="mouth"></span>
                    </span>
                </figure>
                <figure className="ears">
                    <span className="ear ear-left top"></span>
                    <span className="ear ear-left middle"></span>
                    <span className="ear ear-left bottom"></span>
                    <span className="ear ear-right top"></span>
                    <span className="ear ear-right middle"></span>
                    <span className="ear ear-right bottom"></span>
                </figure>
                <figure className="legs">
                    <span className="leg-left"></span>
                    <span className="leg-right"></span>
                </figure>
            </div>
            <figure className="shadow"></figure>
        </div>
    );
};
